class ProductCompareFooter extends HTMLElement {
  static get observedAttributes() {
    return ['compare-list'];  // 指定观察的属性
  }
  constructor() {
    super();
  }

  connectedCallback() {
    const ids = JSON.parse(localStorage.getItem('compares') || '[]');
    const idsData = $(this).data('ids').split(',').map(Number);
    if(window.innerWidth < 750) {
      idsData.pop();
    }
    this.vue = new Vue({
      el: '#product-compare-footer',
      delimiters: ['${', '}'],
      async created(){
        if(ids.length == 0) {
          localStorage.setItem('compares', JSON.stringify(idsData));
          document.dispatchEvent(new CustomEvent("compare-action-updade"));
        }
        await this.initList();
        if(ids.length) $('.product-compare-footer-wrapper').show();
      },
      data(){
        return {
          products: [],
          loading: true
        }
      },
      methods: {
        handleClearItem(id) {
          const ids = JSON.parse(localStorage.getItem('compares') || '[]');
          const idx = ids.indexOf(id)
          if(idx != -1) {
            ids.splice(idx, 1)
            localStorage.setItem('compares', JSON.stringify(ids));
            this.initList();
            document.dispatchEvent(new CustomEvent("compare-action-updade"));
          }
        },
        handleClearAll() {
          localStorage.setItem('compares', []);
          this.initList();
          document.dispatchEvent(new CustomEvent("compare-action-updade"));
        },
        async getProductData(id) {
          // 构建GraphQL查询
          const query = `
            {
              node(id: "gid://shopify/Product/${id}") {
                ... on Product {
                  id
                  title
                  featuredImage {
                    url
                  }
                }
              }
            }`;

          const url = `/api/2023-10/graphql.json`;
          const headers = {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'eb31aaab0f874a80b1bde7eb2791c6ad',
          };
          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({ query })
            })
            const res = await response.json();
            const graphqlNode = res.data.node;
            if(!graphqlNode) return null;
            const productId = graphqlNode.id.split('/');
            const resData = {
              productId: +productId[productId.length - 1],
              title: graphqlNode.title,
              featuredImage: graphqlNode.featuredImage?.url,
            }
            return resData
          } catch (error) {
          }
        },
        async initList() {
          this.loading = true;
          try {
            const productIdList = JSON.parse(localStorage.getItem('compares') || '[]');
            if(!productIdList.length) {
              $('.product-compare-footer-wrapper').hide();
              return
            }
            const fetchProductList = productIdList.map(productId => this.getProductData(productId));
            this.products = await Promise.all(fetchProductList);
          } catch (err) {
            console.error(err);
          } finally {
            this.loading = false;
          }
        }
      }
    })
    this.setAttribute('compare-list', ids);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    const ids = new Array(newValue)
    if(ids.length > 0) {
      $('.product-compare-footer-wrapper').show();
      this.vue.initList();
    }
  }
}

customElements.define("product-compare-footer", ProductCompareFooter);
